import React from 'react'
import { Redirect } from "react-router-dom";

export default class EmailForm extends React.Component {
  state = {
    submitted: false,
    email: "",
    error: false
  }

  emailIsValid(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  submit = (ev) => {
    ev.preventDefault();
    if (this.state.email && this.emailIsValid(this.state.email)) {
      fetch('https://ops-corpsite.builtwithdark.com/signup', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: this.state.email,
        })
      })

      this.setState({
        submitted: true,
        error: false
      })
    }else{
      this.setState({
        error: true
      })
    }
  }

  render() {
    if (this.state.submitted) {
      return <Redirect to={{
        pathname: '/beta',
        state: { 
          submitted: true, 
          email: this.state.email,
        }
      }} />
    }
    let { inputInfo } = this.props  
    return (
      <div className="EmailFormWrapper">
        <p className={("paragraph-text form-error-txt light-purple " + (this.state.error? "" : "hide"))}>Please enter a valid email</p>
        <form onSubmit={this.submit} className={("EmailForm " + inputInfo.class)}>
          <input value={this.state.email}
            onChange={(ev) => this.setState({ email: ev.target.value })}
            placeholder={inputInfo.placeholder} />
          <button type="submit" className={"EmailForm-button MankSans-Medium paragraph-text"}>
          {inputInfo.btnText}
          </button>
        </form>
      </div>
    )
  }
}
